import { useTranslation } from "react-i18next";

import LearnerPortalShell from "@/components/learner/LearnerPortalShell";
import RuleDiffForm from "@/components/RuleDiffForm";

/**
 * apps/web :: pages :: RuleDiffPreviewPage
 *
 * Authenticated-only preview / playground for the rule-diff engine MVP
 * (ADR-0009 Tier-1 first caller). Wrapped by `<ProtectedRoute>` in
 * App.tsx so anonymous visitors are bounced to /login.
 *
 * This is a validation surface, not the production learner wizard — it
 * lets the team inspect raw model output against the three benchmark
 * language pairs (India→CA Telugu, Mexico→TX Spanish, Ukraine→NY
 * Russian) plus a generic fallback. No styling polish beyond the current
 * Tailwind preset.
 */
export default function RuleDiffPreviewPage() {
  const { t } = useTranslation();

  return (
    <LearnerPortalShell pageTitle={t("ruleDiff.title")}>
      <section className="mx-auto max-w-3xl px-md pt-xl pb-xl sm:px-lg sm:pt-2xl sm:pb-2xl">
        <header className="max-w-2xl">
          <p className="text-sm font-semibold uppercase tracking-wide text-neutral-600">
            {t("ruleDiff.eyebrow")}
          </p>
          <h1 className="mt-sm font-display text-3xl font-bold tracking-tight text-brand-primary sm:text-4xl">
            {t("ruleDiff.title")}
          </h1>
          <div className="mt-md h-1 w-16 rounded-full bg-brand-accent" aria-hidden="true" />
          <p className="mt-md text-base text-neutral-800">
            {t("ruleDiff.subtitle")}
          </p>
        </header>

        <div className="mt-xl">
          <RuleDiffForm />
        </div>
      </section>
    </LearnerPortalShell>
  );
}
